function escapeBadgeText(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Tags in block settings (commas and/or line breaks); match if product has any (OR). */
function badgeTitleMatchesProduct(titleField, product_tags) {
  let configured = String(titleField || '')
    .replace(/\r\n/g, '\n')
    .split(/[,\n]+/)
    .map((t) => t.trim())
    .filter(Boolean);
  if (!configured.length) return false;
  return configured.some((t) => product_tags.indexOf(t) !== -1);
}

function isTextProductBadge(badge) {
  return (
    badge.badge_type === 'text' &&
    badge.badge_text &&
    String(badge.badge_text).trim() !== ''
  );
}

function buildProductBadgeHtml(product_badge) {
  const isText = isTextProductBadge(product_badge);

  if (isText) {
    const bg = product_badge.badge_background || '#ffffff';
    const fg = product_badge.badge_color || '#000000';
    const label = escapeBadgeText(product_badge.badge_text.trim());
    return `
            <div class="product-badge product-badge--text">
              <span class="product-badge__label" style="background-color:${bg};color:${fg};">${label}</span>
            </div>
          `;
  }

  let svg = product_badge.badge_svg;
  if (svg) {
    svg = String(svg).replaceAll('clip-path=', 'clip-path--x=');
  }
  const imgSrc =
    typeof product_badge.badge_img === 'string'
      ? product_badge.badge_img
      : product_badge.badge_img && product_badge.badge_img.src;
  return `
            <div class="product-badge">
              ${svg || `<img src="${imgSrc || ''}" alt="" />`}
            </div>
          `;
}

/**
 * Preserve PRODUCT_BADGES order.
 * Consecutive text badges: one inner stack if 2+, else single pill.
 * Each image/SVG badge: its own block (multiple graphics stack in the root column).
 */
function buildProductTagBadgesMarkup(product_badges) {
  const parts = [];
  let textRun = [];

  const flushTextRun = () => {
    if (!textRun.length) return;
    if (textRun.length === 1) {
      parts.push(buildProductBadgeHtml(textRun[0]));
    } else {
      parts.push(
        `<div class="product-badges-stack">${textRun.map(buildProductBadgeHtml).join('')}</div>`
      );
    }
    textRun = [];
  };

  product_badges.forEach((badge) => {
    if (isTextProductBadge(badge)) {
      textRun.push(badge);
    } else {
      flushTextRun();
      parts.push(buildProductBadgeHtml(badge));
    }
  });
  flushTextRun();

  if (!parts.length) return '';
  return `<div class="product-tag-badges-root">${parts.join('')}</div>`;
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductBadgeItem', () => ({
    mounted() {
      let am = this;
      am.AddBadges();
      document.addEventListener('product-images-loaded', am.AddBadges.bind(am));
      am.UpdateProductTitle();
    },
    AddBadges() {
      let am = this;
      let $product = am.$el;
      if (!PRODUCT_BADGES || !$product) return;

      let product_tags = $product.dataset.productTags
        .split('~')
        .map((t) => t.trim())
        .filter(Boolean);
      let product_badges = [];
      PRODUCT_BADGES.forEach((badge) => {
        if (badgeTitleMatchesProduct(badge.title, product_tags)) {
          product_badges.push(badge);
        }
      });

      let $item_wrap = $product.querySelector('.grid-product__content') || $product.querySelector('.media-slide:first-of-type .product-image-main');
      if (!$item_wrap) return;

      $item_wrap.querySelector('.product-tag-badges-root')?.remove();
      $item_wrap.querySelector('.product-badges-stack')?.remove();

      let tagBadgesMarkup = buildProductTagBadgesMarkup(product_badges);
      if (tagBadgesMarkup) {
        $item_wrap.insertAdjacentHTML('afterBegin', tagBadgesMarkup);
      }

      // console.log(licence_badgeS);
      let licence_tags = LICENCE_BADGES.map(item => item.tag);

      // console.log(product_tags);
      licence_tags.forEach(licence_tag => {
        if (product_tags.includes(licence_tag)) {
          // console.log(licence_tag);
          let licence_badge = LICENCE_BADGES.find(item => item.tag == licence_tag);
          if (licence_badge && !$item_wrap.querySelector('.brand-badge')) {
            let $image_wrap = $item_wrap.querySelector('.grid-product__image-mask') || $item_wrap.querySelector('.image-wrap');
            // console.log(licence_badge);
            $image_wrap.insertAdjacentHTML('beforeend', licence_badge.html);
          }
        }
      });
    },
    UpdateProductTitle() {
      let am = this;
      let $title = am.$el.querySelector('.grid-product__title');
      if (!$title) return;
      if ($title.innerHTML.split(' ').length > 3) return;

      $title.innerHTML = $title.innerHTML.replace(/ (?=[^ ]*$)/i, ' <br class="medium-up--hide" />');
    }
  }));

  Alpine.data('ProductItemSaleInfo', () => ({
    init() {
      this.InitSelf();
    },
    InitSelf() {
      if (!theme.settings.show_grid_product_sale_info) return;
      this.$el.innerHTML = theme.settings.grid_product_sale_info;
      this.$el.style.setProperty('--sale-badge-bg', theme.settings.grid_product_sale_info_bg_color);
      this.$el.style.setProperty('--sale-badge-color', theme.settings.grid_product_sale_info_text_color);
    }
  }));
});
